import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e31717d0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "row" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-3" }, null, -1))
const _hoisted_3 = { class: "col-6 text-center" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", { class: "fw-bolder text-uppercase mb-0" }, " Tình hình nhập - xuất tồn kho ", -1))
const _hoisted_5 = {
  class: "fst-italic mb-0",
  style: {"font-size":"0.8rem"}
}
const _hoisted_6 = {
  key: 0,
  class: "mb-0",
  style: {"font-size":"0.85rem"}
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-3" }, null, -1))
const _hoisted_8 = { class: "row mt-2" }
const _hoisted_9 = { class: "col-12" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "d-flex justify-content-end mx-5 mt-4",
  style: {"font-size":"0.8rem"}
}, [
  /*#__PURE__*/_createElementVNode("p", { class: "fst-italic" }, "Ngày .... Tháng .... Năm ....")
], -1))

import { computed, PropType } from "vue";
import {
  INhapXuatTonKhoDonViMeta,
  INhapXuatTonKhoRowResponseBase,
} from "@/core/interfaces/ApiResponses";
import {
  getPdfPrintContentStyle,
  PDF_BAO_CAO_MARGINS,
} from "@/components/shared/pdf-viewer/pdf-content.config";
import NhapXuatTonKhoTable from "../table-components/NhapXuatTonKhoTable.vue";
import PdfDocumentHeader from "@/components/shared/pdf-viewer/PdfDocumentHeader.vue";
import { useAuthPdfDonVi } from "@/core/hooks/use-auth-pdf-don-vi";


export default /*#__PURE__*/_defineComponent({
  __name: 'NhapXuatTonKhoPrintTemplate',
  props: {
  tenDonVi: { type: String, default: "" },
  tenDonViCha: { type: String, default: "" },
  items: {
    type: Array as PropType<INhapXuatTonKhoRowResponseBase[]>,
    default: () => [],
  },
  donVi: {
    type: Array as PropType<INhapXuatTonKhoDonViMeta[]>,
    default: () => [],
  },
  fromMonth: { type: Number, default: null },
  toMonth: { type: Number, default: null },
  year: { type: [String, Number], default: "" },
  nhomVatTu: { type: String, default: "" },
},
  setup(__props) {

const paperStyle = getPdfPrintContentStyle({
  orientation: "landscape",
  margins: PDF_BAO_CAO_MARGINS,
});

const props = __props;

const authDonVi = useAuthPdfDonVi();
const resolvedTenDonVi = computed(
  () => props.tenDonVi || authDonVi.tenDonVi.value
);
const resolvedTenDonViCha = computed(
  () => props.tenDonViCha || authDonVi.tenDonViCha.value
);


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "printing-paper",
    style: _normalizeStyle(_unref(paperStyle))
  }, [
    _createVNode(PdfDocumentHeader, {
      "ten-don-vi": resolvedTenDonVi.value,
      "ten-don-vi-cha": resolvedTenDonViCha.value
    }, null, 8, ["ten-don-vi", "ten-don-vi-cha"]),
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("p", _hoisted_5, " Từ tháng " + _toDisplayString(__props.fromMonth) + " đến tháng " + _toDisplayString(__props.toMonth) + " năm " + _toDisplayString(__props.year), 1),
        (__props.nhomVatTu)
          ? (_openBlock(), _createElementBlock("p", _hoisted_6, " Nhóm, loại vật tư: " + _toDisplayString(__props.nhomVatTu), 1))
          : _createCommentVNode("", true)
      ]),
      _hoisted_7
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("div", _hoisted_9, [
        _createVNode(NhapXuatTonKhoTable, {
          "is-print-modal": true,
          items: __props.items,
          "don-vi": __props.donVi,
          stripe: false
        }, null, 8, ["items", "don-vi"])
      ])
    ]),
    _hoisted_10
  ], 4))
}
}

})